<template>
     <div id="tablePrint">
        <b-table
            show-empty
            responsive
            :items="category"
            :fields="fields"
            :per-page="($route.name == 'categoryproduct') ? search.perPage+1 : search.perPage"
            :busy="addCategory.isLoadTable"
            class="scroll-bar-pop text-center"
            empty-text="คุณยังไม่มีรายการหมวดหมู่ กรุณาเพิ่มรายการของคุณ"
            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
        >
            <div slot="table-busy" class="text-center">
                <div class="text-center text-primary my-2">
                    <i class="fas fa-circle-notch fa-spin"></i>
                    <strong> Loading...</strong>
                </div>
            </div>
            <template slot="index" slot-scope="data">{{ getOverAllIndex( data.index ) }}</template>
            <template slot="manage" slot-scope="data">
                <router-link :to="checkRoute(data.item.id)" class="px-2">
                    <b-button
                        size="sm" 
                        variant="default" 
                        class="px-3" 
                        @click="search.name = ''"
                    >
                    <i class="fas fa-cog"></i> จัดการ
                    </b-button>
                </router-link>
                <b-button
                    v-if="!checkDefaultCategory( data.item.id )"
                    size="sm" 
                    variant="info" 
                    class="px-3"
                    @click="openModalEditCategory( data.item.id )"
                >
                    <i class="fas fa-circle-notch fa-spin" v-if="addCategory.categoryId == data.item.id"></i>
                    <i class="fas fa-pen" v-else></i> แก้ไข
                </b-button>
                <b-button
                    v-if="!checkDefaultCategory( data.item.id )"
                    size="sm" 
                    variant="danger" 
                    class="px-3" 
                    @click="openModalDeleteCategory( data.item )"
                >
                    <i class="fas fa-trash-alt"></i> ลบ
                </b-button>
            </template>
        </b-table>
        <div class="mt-3">
            <b-pagination 
                :total-rows="search.totalItem"
                :current-page="search.page"
                :per-page="search.perPage"
                :value="search.page" 
                @input="changePage"
                align="right">
            </b-pagination>
        </div>  
        <ModalConfirm
            ref="confirmDelete"
            :confirm="confirm"
            @confirmModal="checkConfirmModal()"
        />         
    </div>
</template>

<script>
import ModalConfirm from '@/components/Modals//ModalConfirm'
import { getCategoryDetail , deleteCategory } from "@/axios/service.js";
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";

export default {
    props:{
        search: Object,
        category: Array,
        addCategory: Object
    },
    components:{
        ModalConfirm
    },
    data(){
        return{
            confirm: {
                show: false,
                icon: "",
                emphasize: "",
                text: "",
                isLoad: false
            }
        }
    },
    methods:{
        getOverAllIndex(index){
            return ( this.search.page * 25 ) - 25 + index + 1
        },
        changePage(i){
            if (this.search.page == i) return;
            this.search.page = i
            this.$emit('getApiCategoryService');
        },
        openModalEditCategory( id ){
            this.addCategory.categoryId = id
            getCategoryDetail( this.addCategory.categoryId ).then( res => {
                this.addCategory.name = res.name;
                this.addCategory.image.preview = res.image
                this.addCategory.show = true
            }).catch( error => {
                showErrorModal(error)
            });
        },
        openModalDeleteCategory( item ){
            this.confirm.show = true
            this.confirm.icon = '<i class="fas fa-trash-alt text-red fa-2x"></i>'
            this.confirm.emphasize = `ลบหมวดหมู่ ${item.name}`
            this.confirm.text = 'บริการเสริมที่อยู่ในหมวดหมู่นี้ จะถูกลบออกจากระบบด้วย คุณต้องการที่จะลบหรือไม่'
            this.addCategory.categoryId = item.id
        },
        checkConfirmModal(){
            this.confirm.isLoad = true;
            deleteCategory(this.addCategory).then( res => {
                this.addCategory.categoryId = null
                this.$refs.confirmDelete.closeModalConfirm();
                showSuccessModal('ลบหมวดหมู่สำเร็จ')
                this.$emit('getApiCategoryService');
            }).catch( error => {
                showErrorModal(error)
                this.confirm.isLoad = false
            });
        },
        checkRoute( catedoryId ){
            return ( this.$route.name == 'categoryservice' ) ? `/service/${catedoryId}` : `/product/${catedoryId}`
        },
        checkDefaultCategory( categoryId ){
            return categoryId == 0;
        }
    },
    computed:{
        fields(){ 
            let fields = [
                { key: "index", label: "ลำดับ", sortable: true },
                { key: "name", label: "ชื่อหมวดหมู่", sortable: true },
                { key: "manage", label: "จัดการ" }
            ]
            return fields
        }
    }
}
</script>